(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '${{amount}}').replace('{{amount}}', value);
  }

  function getVariantFromOptions(variants, selectedOptions) {
    return variants.find(function (variant) {
      return selectedOptions.every(function (value, index) {
        return variant.options[index] === value;
      });
    });
  }

  function initVariantPicker(root) {
    var picker = root.querySelector('[data-variant-picker]');
    var select = root.querySelector('[data-variant-select]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var buyNowButton = root.querySelector('[data-buy-now]');
    var priceCurrent = root.querySelector('[data-price-current]');

    if (!picker || !select) return;

    var variants = [];
    var jsonScript = picker.querySelector('[data-product-json]');
    try {
      variants = jsonScript ? JSON.parse(jsonScript.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var optionGroups = picker.querySelectorAll('[data-option-index]');
    var selectedOptions = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector('.is-selected');
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      selectedOptions[index] = active ? active.getAttribute('data-option-value') : null;
    });

    function updateUI(variant) {
      if (!variant) return;

      select.value = variant.id;

      if (priceCurrent) {
        priceCurrent.textContent = formatMoney(variant.price);
      }

      if (addButton) {
        var textEl = addButton.querySelector('[data-add-to-cart-text]');
        if (variant.available) {
          addButton.removeAttribute('disabled');
          if (textEl) textEl.textContent = 'Add to Cart';
        } else {
          addButton.setAttribute('disabled', 'disabled');
          if (textEl) textEl.textContent = 'Sold Out';
        }
      }

      if (buyNowButton) {
        buyNowButton.style.display = variant.available ? '' : 'none';
      }

      document.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
        if (variant.featured_media && slide.getAttribute('data-media-id') === String(variant.featured_media.id)) {
          document.querySelectorAll('[data-gallery-slide]').forEach(function (s) {
            s.classList.remove('is-active');
          });
          slide.classList.add('is-active');
        }
      });
    }

    picker.querySelectorAll('[data-option-value]').forEach(function (button) {
      button.addEventListener('click', function () {
        var index = parseInt(button.getAttribute('data-option-index'), 10);
        var value = button.getAttribute('data-option-value');
        selectedOptions[index] = value;

        var group = picker.querySelector('[data-option-index="' + index + '"]');
        if (group) {
          group.querySelectorAll('[data-option-value]').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          button.classList.add('is-selected');
          var selectedLabel = group.querySelector('[data-selected-value]');
          if (selectedLabel) selectedLabel.textContent = value;
        }

        var matched = getVariantFromOptions(variants, selectedOptions);
        updateUI(matched);
      });
    });
  }

  function initQuantitySelector(root) {
    var wrapper = root.querySelector('[data-quantity-selector]');
    if (!wrapper) return;
    var input = wrapper.querySelector('[data-quantity-input]');
    var minus = wrapper.querySelector('[data-quantity-minus]');
    var plus = wrapper.querySelector('[data-quantity-plus]');

    if (minus) {
      minus.addEventListener('click', function () {
        var val = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.value = val;
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value || '1', 10) + 1;
        input.value = val;
      });
    }
  }

  function initAddToCart(root) {
    var form = root.querySelector('.product-form');
    if (!form) return;
    var errorEl = root.querySelector('[data-product-form-error]');
    var addButton = form.querySelector('[data-add-to-cart]');
    var spinner = form.querySelector('[data-add-to-cart-spinner]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (addButton) addButton.setAttribute('disabled', 'disabled');
      if (spinner) spinner.hidden = false;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          if (window.updateCartCount) window.updateCartCount(cart.item_count);
          if (window.openCartDrawer) window.openCartDrawer();
          if (window.refreshCartDrawer) window.refreshCartDrawer();
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = (err && err.description) || 'Something went wrong. Please try again.';
          }
        })
        .finally(function () {
          if (addButton) addButton.removeAttribute('disabled');
          if (spinner) spinner.hidden = true;
        });
    });

    var buyNowButton = root.querySelector('[data-buy-now]');
    if (buyNowButton) {
      buyNowButton.addEventListener('click', function () {
        buyNowButton.setAttribute('disabled', 'disabled');
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowButton.removeAttribute('disabled');
            window.location.href = '/cart';
          });
      });
    }
  }

  document.querySelectorAll('.product-section').forEach(function (root) {
    initVariantPicker(root);
    initQuantitySelector(root);
    initAddToCart(root);
  });
})();
